export const tableColumnTitles = {
  date: 'Date',
  totalRevenue: 'Total Revenue',
  newSubs: 'New Subs',
  newSubscriptionsRevenue: 'New Subs Revenue',
  recurringSubscriptionsRevenue: 'Rec. Subs Revenue',
  tipsRevenue: 'Tips Revenue',
  messageRevenue: 'Message Revenue',
  textingRatio: 'Texting Ratio',
  openChats: 'Open Chats',
  sellingChats: 'Selling Chats',
  averageFanSpend: 'Average Fan Spend',
  linkClicks: 'Link Clicks',
  conversionRate: 'Conversion Rate',
} as const
